import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  container: {
    position: 'absolute',
    right: 20,
    bottom: 20,
  },
}));
